/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  /* Base ":host" styles for the component */
  box-sizing: border-box;
  background-color: var(--calcite-color-foreground-1);
  color: var(--calcite-color-text-2);
  font-size: var(--calcite-font-size--1);
}
:host * {
  box-sizing: border-box;
}

:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host {
  display: flex;
  inline-size: 100%;
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

.container {
  display: flex;
  inline-size: 100%;
  padding: 0.5rem;
}

label {
  position: relative;
  margin-inline: 0.25rem;
  margin-block: 0px;
  display: flex;
  inline-size: 100%;
  align-items: center;
  overflow: hidden;
}

input[type=text] {
  margin-block-end: 0.25rem;
  inline-size: 100%;
  border-style: none;
  background-color: transparent;
  padding-block: 0.25rem;
  font-family: inherit;
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
  color: var(--calcite-color-text-1);
  padding-inline-end: 0.25rem;
  padding-inline-start: 1.5rem;
  transition: padding var(--calcite-animation-timing), box-shadow var(--calcite-animation-timing);
}
input[type=text]::-ms-clear {
  display: none;
}

calcite-input {
  inline-size: 100%;
}

.search-icon {
  position: absolute;
  display: flex;
  color: var(--calcite-color-text-2);
  inset-inline-start: 0;
  transition: inset-inline-start var(--calcite-animation-timing), inset-inline-end var(--calcite-animation-timing), opacity var(--calcite-animation-timing);
}

input[type=text]:focus {
  border-color: var(--calcite-color-brand);
  outline: 2px solid transparent;
  outline-offset: 2px;
  padding-inline: 0.25rem;
}
input[type=text]:focus ~ .search-icon {
  inset-inline-start: calc(1rem * -1);
  opacity: 0;
}

.clear-button {
  display: flex;
  cursor: pointer;
  align-items: center;
  border-width: 0px;
  background-color: transparent;
  color: var(--calcite-color-text-2);
}
.clear-button:hover, .clear-button:focus {
  color: var(--calcite-color-text-1);
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}